import type { ModuleKey } from '@erp/rpc';

/**
 * Chat modules that continue ONE conversation as the user moves between
 * pages: the page-less `home` module and the OMS page surfaces. Every other
 * module owns its own conversation, so switching to it starts a fresh thread.
 *
 * Typed as strings because `oms` joins `ModuleKeySchema` in the backend
 * contract PR; keying on the wire value keeps this file compiling either way.
 */
const SHARED_THREAD_MODULES: ReadonlySet<string> = new Set(['home', 'oms']);

/** Whether a turn on module `next` may continue a thread started on `prev`. */
export function sharesThread(prev: ModuleKey, next: ModuleKey): boolean {
  if (prev === next) return true;
  return SHARED_THREAD_MODULES.has(prev) && SHARED_THREAD_MODULES.has(next);
}
